<template>
    <div style="padding: 50px 100px;box-sizing: border-box;">
        <div class="titles">{{title}}</div>
        <div style="height: auto;" v-html="text"></div>
    </div>
</template>
<script>
import axios from 'axios';
    export default {
        name: 'NewsInfo',
        data() {
            return {
                text: '',
                title: ''
            }
        },
        mounted() {
            this.viewDetail(this.$route.query.id)
        },
        methods: {
            viewDetail(id){
                var that = this
                axios.defaults.headers.common['APPKEY'] = 'official';
                var query = {news_id: id}
                axios.post('https://www.zhelihao123.com/user/member/news/detail',query)
                    .then(response => {
                        that.text = response.data.data.desc
                        that.title = response.data.data.title
                    })
            },
            login(){
                window.open('https://llhsh.zhelihao123.com/admin/')
            },
            getInfo(){
				var that = this
                // newList().then(res=>{
                //     console.log('新闻='+JSON.stringify(res))
                // })
				axios.defaults.headers.common['APPKEY'] = 'official';
                var query = {}
                axios.post('https://www.zhelihao123.com/user/member/news/index',query)
                    .then(response => {
                        console.log('新闻='+JSON.stringify(response))
						that.list = response.data.data.data
                })
            }
        },
        computed: {

        },
    }
</script>

<style scoped>
.newsBox{width: 90%;margin: 60px 0;margin-left: 5%;}
.newsItem{display: flex;align-items: center;padding: 20px 100px;box-sizing: border-box;}
.titles{color: #333;font-size: 1.8em;margin-bottom: 50px;font-weight: bold;}
.infos{color: #333;font-size: 1.3em;margin-top: 15px;}
</style>